<template>
  <sign-page
    title-text="命令模版"
    :request="request"
    :column-list="columnList"
    :form-parms-add="formParmsAdd"
    :form-parms-update="formParmsUpdate"
    :need-data-file="true">
  </sign-page>
</template>

<script>
import {
  cmdTypeRequest as request
} from '@/api'

export default {
  computed: {
    formParmsAdd: {
      get () {
        let data = [{
          type: 'input',
          label: '名称',
          key: 'name',
          check: {
            required: true
          }
        },
        {
          type: 'textarea',
          label: '所需文件名称',
          key: 'filename'
        },
        {
          type: 'textarea',
          label: '执行命令',
          key: 'cmdInfo'
        },
        {
          type: 'textarea',
          label: '检查命令',
          key: 'checkInfo'
        },
        {
          type: 'textarea',
          label: '默认配置',
          key: 'defaultConfig'
        }]
        return data
      }
    },
    formParmsUpdate: {
      get () {
        let data = []
        this.formParmsAdd.forEach((item) => {
          let newItem = {}
          for (let key in item) {
            newItem[key] = item[key]
          }
          data.push(newItem)
        })
        return data
      }
    },
    columnList: {
      get () {
        let data = []
        this.formParmsAdd.forEach((item) => {
          data.push({
            field: item.key,
            title: item.label
          })
        })
        return data
      }
    }
  },
  data () {
    return {
      request: request
    }
  }
}
</script>
